module.exports = __webpack_public_path__ + "img/streetcrypto.dfc27c1a.png";